// removed by extract-text-webpack-plugin
module.exports = {"frameBarBottom":"src-styles----frameBars-module---frameBarBottom---3XMUv","frameBarTop":"src-styles----frameBars-module---frameBarTop---1i0B6","frameBarLeft":"src-styles----frameBars-module---frameBarLeft---189Dp","frameBarRight":"src-styles----frameBars-module---frameBarRight---21ONo","frameBarBottomZ":"src-styles----frameBars-module---frameBarBottomZ---3zxWA"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/frameBars.module.styl
// module id = 289
// module chunks = 114276838955818